import { memo, useMemo } from 'react';
import { useStore } from '@/store';
import { CharacterRoutePlaceInfo, PageMode } from '@/store/types';
import { Image } from "@shuwen/wenlv-web-activity-library";
import { useSpring, animated } from '@react-spring/web';
import styles from './index.module.scss';
import { getAssetUrl } from '@/utils/common';

interface CharacterSpotProps {
  card: CharacterRoutePlaceInfo;
  index: number;
}


const CharacterSpot = ({ card, index }: CharacterSpotProps) => {
  const setRouteTimeLineDetailId = useStore((state) => state.setRouteTimeLineDetailId);
  const mode = useStore((state) => state.mode);
  const setMode = useStore((state) => state.setMode);
  const setRouteDetailMode = useStore((state) => state.setRouteDetailMode);

  const { x, y, hot, name, birthDay, addr, targetImg } = useMemo(() => {
    const { content, x, y, hot, name } = card;
    if (content) {
      const [name, birthDay, addr] = content?.split('\n');
      const targetImg = card?.ext_materialList?.find(i => i?.tagList?.includes('大屏展项素材'))?.cover || '';
      return {
        x, y, hot, name, birthDay, addr, targetImg
      }
    }

    return {
      x, y, hot: '', name: name ? name : '', birthDay: '', addr: '', targetImg: ''
    }
  }, [card]);

  const spring = useSpring({
    from: { scale: 0, opacity: 0 },
    to: { scale: 1, opacity: 1 },
    delay: index * 50,
    config: {
      tension: 180 * 2,
      friction: 12,
    }
  });

  return (
    <animated.div
      className={styles.characterSpot}
      style={{
        left: `${x}%`,
        top: `${y}%`,
        ...spring
      }}
      onClick={() => {
        // if (mode === PageMode.ROUTE_THEME_LIST) {
        //   return setRouteTimeLineDetailId(card.entity_id);
        // }
        // setMode(PageMode.ROUTE_CHARACTER_TRACK_SINGLE);
        setRouteDetailMode(card?.entity_id);
      }}
    >
      {/* <div className={styles.bgLine}>
        <div className={styles.line} />
        <div className={styles.circle} />
        <div className={styles.num}>{hot}</div>
      </div> */}
      <div className={styles.characterSpotContent}>
        <div className={styles.avatarContainer}>
          <Image
            src={targetImg || card?.image || getAssetUrl('images/bg.png')}
            alt={name}
            className={styles.avatar}
          />
        </div>
      </div>
      <div className={styles.info}>
        <div className={styles.name}>{name}</div>
        <div className={styles.birthDay}>{birthDay}</div>
        <div className={styles.addr}>{addr}</div>
      </div>
    </animated.div>
  );
};

export default memo(CharacterSpot); 